var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviders = function SvgProviders(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    "data-width-28": 23,
    "data-width-72": 59,
    viewBox: "0 0 9.8 7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.143 6.235H6.14a.4.4 0 0 0 .11-.015h.487a1.08 1.08 0 0 0 1.023.72 1.08 1.08 0 0 0 1.008-.705h.047a.935.935 0 0 0 .935-.95V4.16A3.19 3.19 0 0 0 6.565.97h-.05V.94A.94.94 0 0 0 5.58 0H.94A.94.94 0 0 0 0 .94V5.3a.94.94 0 0 0 .94.935h.177a1.1 1.1 0 0 0 .417.525 1.08 1.08 0 0 0 1.609-.525m0-.75h2.622V.94A.19.19 0 0 0 5.58.75H.94a.19.19 0 0 0-.19.19V5.3a.19.19 0 0 0 .19.185h.177a1.08 1.08 0 0 1 2.026 0m-1.338.46A.4.4 0 0 0 1.81 5.8a.324.324 0 0 1 .325-.266.325.325 0 0 1 .325.325.33.33 0 0 1-.655.084m5.63-.1a.4.4 0 0 1-.007.073.33.33 0 1 0 .657-.058.325.325 0 0 0-.325-.325.325.325 0 0 0-.326.277zm-.92-.375h.233a1.08 1.08 0 0 1 2.02.015h.047A.19.19 0 0 0 9 5.3V4.175a2.44 2.44 0 0 0-2.435-2.44h-.05z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviders);
export default ForwardRef;